import axios from "axios";
import { createContext, useEffect, useReducer, useState } from "react";
import { useTenant } from "../hooks";

const accountBookContext = createContext();

const accountBookReducer = (state, action) => {
  switch (action.type) {
    case "SET_ACCOUNTS_BOOK":
      return {
        ...state,
        accountsBook: action.payload,
      };
    case "EDIT_ACCOUNT_TO_BOOK":
      return {
        ...state,
        accountsBook: action.payload,
      };
    default:
      return state;
  }
};

export const AccountBookProvider = ({ children }) => {
  const [state, dispatch] = useReducer(accountBookReducer, {
    accountsBook: {},
  });
  const { tenantId, companySelected } = useTenant();
  const BaseUrl = process.env.REACT_APP_INV_API_SERVER_BASE_URL;
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const fetchAccountsBook = async () => {
    try {
      if (!tenantId || !companySelected?.value) {
        setLoading(false);
        return null;
      }
      setLoading(true);
      const response = await axios.post(`${BaseUrl}/accounts-book`, {
        tenant_id: tenantId,
        company_id: companySelected?.value,
      });
      const payload = response?.data.data || {};
      dispatch({
        type: "SET_ACCOUNTS_BOOK",
        payload,
      });
      console.log(response);

      return payload;
    } catch (error) {
      console.log(error);
      return null;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (tenantId && companySelected?.value) {
      fetchAccountsBook();
    }
  }, [tenantId, companySelected?.value]);

  const saveAccountsBook = async (accountData) => {
    try {
      if (!tenantId || !companySelected?.value) return null;
      setSaving(true);
      const response = await axios.post(`${BaseUrl}/accounts-book/store`, {
        tenant_id: tenantId,
        company_id: companySelected?.value,
        ...accountData,
      });
      const payload = response?.data.data || {};
      dispatch({
        type: "SET_ACCOUNTS_BOOK",
        payload,
      });
      fetchAccountsBook();
      return payload;
    } catch (error) {
      console.error("Failed to save accounts book:", error);
      return null;
    } finally {
      setSaving(false);
    }
  };

  const value = {
    accountsBook: state.accountsBook,
    loading,
    saving,
    dispatch,
    fetchAccountsBook,
    saveAccountsBook,
    editAccountBook: saveAccountsBook,
  };

  return (
    <accountBookContext.Provider value={value}>
      {children}
    </accountBookContext.Provider>
  );
};

export default accountBookContext;
